/**
 * The wordmark.
 *
 * A Kontor is the old counting-house — the room where the books were kept. The mark
 * is set in the same Plex Mono the application uses for figures, with the ledger
 * rule beneath it doing the work an icon would otherwise do. No logotype, no glyph:
 * this is a tool that lives behind a login, not a brand that needs to be recognised
 * across a trade fair.
 */
export function Wortmarke({ invers = false }: { invers?: boolean }) {
  return (
    <span
      className="inline-flex flex-col"
      style={{
        color: invers ? "var(--text-inverse)" : "var(--text-primary)",
        // As a child of a column flex container the default `align-self: stretch`
        // would pull the ledger rule across the whole panel. Set here rather than
        // via a utility class so the mark is correct wherever it is placed.
        alignSelf: "flex-start",
      }}
    >
      <span
        className="font-[var(--font-mono)] leading-none"
        style={{
          fontSize: "var(--text-md)",
          fontWeight: "var(--weight-medium)",
          letterSpacing: "0.14em",
        }}
      >
        KONTOR
      </span>
      <span
        aria-hidden="true"
        className="mt-[5px] block"
        style={{
          height: "2px",
          background: invers ? "var(--accent-solid)" : "var(--accent-solid)",
          width: "100%",
        }}
      />
    </span>
  );
}
